import { bekki } from '@/config/endpointsConfig';

const { url: BEKKI_ROOT, basePath: BEKKI_BASE_PATH } = bekki;

export const CHAT_MESSAGES_PATH: string = `${BEKKI_ROOT}${BEKKI_BASE_PATH}/messages`;

export const IS_BEKKI_MOCK: boolean = !BEKKI_ROOT;

export const BEKKI_HISTORY_LIMIT = 10;

export const BEKKI_MAX_MESSAGE_LENGTH = 1000;

export const BEKKI_INACTIVITY_TIMEOUT_MS = 90_000;
